export default __webpack_public_path__ + "static/media/sampleFounder.94cbdf93.png";